import React from "react";
import { useSelector } from "react-redux";
import styles from "./NotificationStyles.module.scss";

export default function Notification({ bannerMessage }) {
    const { roomOpen } = useSelector(state => state.room);

    if (!bannerMessage) {
        return null;
    }

    return (
        <header className={styles.appNotification}>
            {bannerMessage}
        </header>
    );
}